import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../../../config/api";
import { BackEndRoutes } from "../../../config/back-end-routes";
import DefaultGrid from "../../../Components/Default/DefaultGrid";
import { FrontEndRoutes } from "../../../config/front-end-routes";
import {toast} from "react-toastify";
import {useFilters} from "../../../Components/Filters/UseFilter";

const PageEditPriceTable: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);
    const [priceTable, setPriceTable] = useState<any>(null);
    const [items, setItems] = useState<any[]>([]);
    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
    const { filters, handleFilterChange } = useFilters([]);

    const fetchPriceTable = async () => {
        setLoading(true);
        try {
            const response = await api.get(BackEndRoutes.routes.TABELA_PRECOS.FIND.replace(":id", id!));
            if (response.data) {
                setPriceTable(response.data);
                setItems(response.data.itens || []);
            }
        } catch (error) {
            console.error("Erro ao carregar tabela de preços:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async () => {
        setLoading(true);
        try {
            await api.put(BackEndRoutes.routes.TABELA_PRECOS.FIND.replace(":id", id!), {
                id_tabela: priceTable.id_tabela,
                descricao: priceTable.descricao,
                status:priceTable.status,
            });
            toast.success("Tabela de preços atualizada com sucesso!");
            navigate(FrontEndRoutes.TABELA.PRECO);
        } catch (error) {
            toast.error("Erro ao salvar tabela de preços")
            console.error("Erro ao salvar tabela de preços:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = () => {
        setLoading(true);
        api
            .delete(BackEndRoutes.routes.TABELA_PRECOS.FIND.replace(":id", id!))
            .then(() => {
                toast.success("Item da tabela de preços excluída com sucesso!");
                navigate(FrontEndRoutes.TABELA.PRECO);
            })
            .catch((error) => {
                toast.error("Erro ao excluir item tabela de preços");
                console.error("Erro ao excluir item tabela de preços:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        if (id) {
            fetchPriceTable();
        }
    }, [id]);

    useEffect(() => {
        if (priceTable?.itens) {
            const flattenedItems = priceTable.itens.map((item: any) => ({
                ...item,
                descricao: item.produto?.descricao,
                modelo: item.produto?.modelo,
                estoque: item.produto?.estoque,
                genero: item.produto?.genero,
                id_ecommerce: item.produto?.id_ecommerce,
                status: item.produto?.status,
            }));
            setItems(flattenedItems);
        }
    }, [priceTable]);

    const columns = [
        { key: "modelo", label: "Modelo", filterType: "text" as const },
        { key: "descricao", label: "Descrição do Produto" },
        { key: "genero", label: "Gênero", filterType: "text" as const },
        { key: "tamanho", label: "Tamanho" },
        // { key: "status", label: "Status", filterType: "text" as const },
        {
            key: "status",
            label: "Status",
            render: (item: any) => (
                <select
                    className="form-select"
                    value={item.status}
                    disabled
                    onChange={(e) => {
                        const newStatus = e.target.value;
                        setItems((prev) =>
                            prev.map((i) =>
                                i.id_produto === item.id_produto
                                    ? { ...i, status: newStatus }
                                    : i
                            )
                        );
                    }}
                >
                    <option value="1">Ativo</option>
                    <option value="0">Inativo</option>
                </select>
            ),
        },
        { key: "estoque", label: "Estoque", filterType: "text" as const },
        { key: "preco_venda", label: "Preço Venda", editable: true },
        { key: "codigo_barras", label: "Código de Barras" },
        { key: "id_ecommerce", label: "Código Ecommerce", filterType: "text" as const },
    ];

    return (
        <div className="d-flex flex-column container-fluid">
            <h1>Edição da Tabela de Preços</h1>
            {loading ? (
                <p>Carregando...</p>
            ) : (
                <>
                    <div className="row mb-2">
                        <div className="col-3">
                            <label>Código</label>
                            <input
                                type="text"
                                className="form-control"
                                value={priceTable?.id_tabela || ""}
                                disabled
                            />
                        </div>
                        <div className="col-6">
                            <label>Descrição</label>
                            <input
                                type="text"
                                className="form-control"
                                value={priceTable?.descricao || ""}
                                onChange={(e) =>
                                    setPriceTable((prev: any) => ({...prev, descricao: e.target.value}))
                                }

                            />
                        </div>
                        <div className="col-3 p-0">
                            <label>Status</label>
                            <select
                                className="form-select"
                                value={priceTable?.status}
                                onChange={(e) => {
                                    const newStatus = e.target.value;
                                    setPriceTable((prev: any) => ({
                                        ...prev,
                                        status: newStatus,
                                    }));
                                }}
                            >
                                <option value="1">Ativo</option>
                                <option value="0">Inativo</option>
                            </select>
                        </div>
                    </div>
                    <DefaultGrid
                        title="Itens da Tabela"
                        columns={columns}
                        filters={filters}
                        handleFilterChange={handleFilterChange}
                        items={items}
                        onDelete={() => setShowDeleteModal(true)}
                        onEditInline={(editedItem: any) => {
                            setItems((prev) =>
                                prev.map((item) => (item.id_produto === editedItem.id_produto ? editedItem : item))
                            );
                        }}
                    />
                    <div className="d-flex justify-content-end mt-3">
                        <button className="btn btn-secondary me-2" onClick={() => navigate(-1)}>
                            Cancelar
                        </button>
                        <button className="btn btn-primary" disabled={loading} onClick={handleSave}>
                            Salvar
                        </button>
                    </div>
                </>
            )}
            {showDeleteModal && (
                <div className="modal" style={{ display: "block" }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirmar Exclusão</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowDeleteModal(false)}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <p>Tem certeza que deseja excluir o item desta tabela de preços?</p>
                            </div>
                            <div className="modal-footer">
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => setShowDeleteModal(false)}
                                >
                                    Cancelar
                                </button>
                                <button
                                    className="btn btn-danger"
                                    onClick={() => {
                                        setShowDeleteModal(false);
                                        handleDelete();
                                    }}
                                >
                                    Excluir
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PageEditPriceTable;
